import { render } from "./StepSix.vue?vue&type=template&id=24dbc1e5"
import script from "./StepSix.vue?vue&type=script&lang=js"
export * from "./StepSix.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__